import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { Alert, Box, CircularProgress } from '@mui/material'
import { API } from 'core/requests'
import { Surveys } from 'pages'
import { getDateLabel } from 'utils/tables/dataTypes'

export default function SurveyPublicPreview() {
  const { token } = useParams<{ token: string }>()

  const { data, isLoading, isError } = useQuery(
    ['surveyPublicPreview', token],
    () => API.get('surveyPublicPreview', null, { pathParams: { token } }),
    { retry: false, refetchOnWindowFocus: false },
  )

  if (isLoading) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='100vh'
      >
        <CircularProgress />
      </Box>
    )
  }

  if (isError || !data?.survey) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='100vh'
        p={3}
      >
        <Alert severity='error'>
          This preview link is invalid or has expired. Please ask the survey
          administrator to generate a new link.
        </Alert>
      </Box>
    )
  }

  return (
    <Box>
      <Alert
        severity='warning'
        sx={{ position: 'sticky', top: 0, zIndex: 1200, borderRadius: 0 }}
      >
        This is a <strong>read-only preview</strong> of the survey{' '}
        <strong>{data.survey.name}</strong>. No responses are recorded.
        {data.expires_at && (
          <>
            {' '}This page will expire and self-destruct on or before{' '}
            <strong>{getDateLabel(data.expires_at)}</strong>.
          </>
        )}
      </Alert>
      <Surveys preview={data.survey} />
    </Box>
  )
}
